import script from "./menu3Form.vue?vue&type=script&setup=true&lang=js"
export * from "./menu3Form.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__